<div class="row">
  <div class="col-12">
    <h2>
      <i class="fas fa-plug"></i>
      <a routerLink="/integrations">Integrations Statistics</a>:
      {{ id$ | async }}
    </h2>
  </div>
</div>

<ng-container *ngIf="isLoading$ | async; else content"
  ><app-loading-spinner></app-loading-spinner
></ng-container>

<ng-template #content>
  <div class="row" [style.marginTop.px]="10">
    <div class="col-12">
      <div class="table-responsive">
        <table class="table bg-white table-hover">
          <thead>
            <tr>
              <th scope="col">Account</th>
              <th scope="col">Sections</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let account of (integration$ | async).accounts">
              <td>
                <a
                  routerLink="/au/accounts/{{ account.accountId }}"
                  fragment="integrations"
                >
                  {{ account.accountId }}
                </a>
              </td>
              <td>{{ account.sections.join(', ') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>
